
export enum NpsType {
  NPS = "NPS",
  CSAT = "CSAT",
  YES_NO = "YES_NO",
  OPEN = "OPEN",
};

export interface NpsInterface {
  id: string;
  label: string;
  order: number;
  type: NpsType;
  required: boolean;
}

export interface NpsAnswer {
  question_id: NpsInterface['id'];
  answer: boolean | number | string;
}

export interface NpsTrigger {
    trigger: boolean;
}
